import { TeamAge } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const teamAgeDictionary = createSimpleDictionary([
    { id: TeamAge.Youth, name: 'dictionaries.teamAge.youth' },
    { id: TeamAge.Senior, name: 'dictionaries.teamAge.senior' },
]);
